import DataTableAdminUsers from "@/components/data-table-admin-users/data-table-admin-users";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useToastError } from "@/components/ui/use-toast";
import { useApi } from "@/hooks/useApi";
import { useTranslation } from "@/hooks/useTranslation";
import { ReloadIcon } from "@radix-ui/react-icons";
import { AdminUserDTO } from "@shaarp/common";
import { useEffect, useState } from "react";

export default function AdministrationUsersPage() {
  const api = useApi();
  const { t } = useTranslation();
  const toastError = useToastError();

  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState<AdminUserDTO[]>([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const { data } = await api.get<AdminUserDTO[]>("/admin/users");
      setUsers(data);
    } catch (error) {
      toastError();
      setUsers([]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="overflow-auto absolute top-0 left-0 flex-1 p-8 pt-6 compact:p-6 compact:pt-4 space-y-4 w-full h-full">
      <div className="flex-1 p-8 pt-0 space-y-5">
        <div className="flex justify-between">
          <div className="space-y-2">
            <h2 className="text-2xl font-bold tracking-tight">
              {t("admin.users.title")}
            </h2>
            <p className="text-muted-foreground">{t("admin.users.subtitle")}</p>
          </div>
          <div className="flex items-center space-x-4">
            <Button variant="outline" onClick={fetchData} disabled={isLoading}>
              <ReloadIcon className="mr-2 w-4 h-4" />
              {t("admin.users.actions.refresh")}
            </Button>
          </div>
        </div>

        <Separator className="my-6" />

        <DataTableAdminUsers
          users={users}
          isLoading={isLoading}
          onRefresh={fetchData}
        />
      </div>
    </div>
  );
}
